<template>
  <div>
    <FormRow class="designation" inline>
      <FormSelect field="custom.designation">
        <option selected="selected" value="Individual summer program">Individual summer program</option>
        <option value="NCSY Summer Scholarship Fund">NCSY Summer Scholarship Fund</option>
        <!-- <option value="NCSY Region">NCSY Region</option> -->
        <option value="Summer 2024 Israel Projects">Summer 2024 Israel Projects</option>
        <!-- <option value="Advisor Development">Advisor Development</option>
        <option value="Education Donation">Education</option>
        <option value="NCSY Alumni">Alumni</option> -->
      </FormSelect>
    </FormRow>
    <FormRow class="designation" inline>

  <div style="max-width: 50%">
      <FormLabel class="control-label" v-if="getValue('custom.designation') == 'Individual summer program'"> Please write name of program
      </FormLabel>
      <FormCol field="custom.subDesignation" :class="{ hidden: getValue('custom.designation') !== 'Individual summer program' }"  class="summerprog" :showLabel="false"/>
   
  </div>


      <ErrorLabel field="custom.designation" style="text-align: right" />
    </FormRow>
  </div>
</template>
<script lang="ts">
import { defineComponent, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { form, getValue, settings, setValue } = usePaymentForm();

    return {
      getValue,
      form,
    };
  },
});
</script>
<style scoped lang="scss">
.designation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width: 50%;
    max-width: 50%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}
.hidden {
  display: none !important;
}
</style>
